const lz = (n: number, min = 2) => {
  return n.toString().padStart(min, '0');
};

export const parseTimestamp = (timestamp: string) => {
  // to HH:MM:SS.mmm

  const date = new Date(timestamp);
  const hours = lz(date.getHours());
  const minutes = lz(date.getMinutes());
  const seconds = lz(date.getSeconds());
  const milliseconds = lz(date.getMilliseconds(), 3);

  return `${hours}:${minutes} ${seconds}.${milliseconds}`;
};
